import ProjectNotes from '../navPages/ProjectNotes'
import ProjectChat from '../navPages/ProjectChat'
import ProjectMap from '../navPages/ProjectMap'
import ProjectTasksCN from '../navPages/ProjectTasksCN'
import ProjectDetails from '../navPages/ProjectDetails'
import ProjectAnalytics from '../navPages/ProjectDemographics'
import ProjectImages from '../navPages/ProjectImages'
import ProjectFiles from '../navPages/ProjectDocuments'
import ProjectPartners from '../navPages/ProjectPartners'
import ProjectReports from '../navPages/ProjectReports'
import LocationAddPartners from '../../locations/components/LocationAddPartners'
import { ProjectFinancials } from 'features/Financials'
import {
	StickyNote,
	MessageSquare,
	Map,
	ListTodo,
	DollarSign,
	Info,
	BarChart3,
	Images,
	FileText,
	FileBarChart,
	Handshake,
} from 'lucide-react'
import routes from 'constants/routes'
import type { Capabilities } from '../../../utils/capabilities'

const getProjectRoutes = (id: string, capabilities?: Capabilities) =>
	[
		{
			linkText: 'Tasks',
			linkTo: `${routes.PROJECTS}/${id}/tasks`,
			linkPattern: `${routes.PROJECTS}/:id/tasks`,
			icon: ListTodo,
			component: ProjectTasksCN,
		},
		{
			linkText: 'Notes ',
			linkTo: `${routes.PROJECTS}/${id}/notes`,
			linkPattern: `${routes.PROJECTS}/:id/notes`,
			icon: StickyNote,
			component: ProjectNotes,
		},
		{
			linkText: 'Chat',
			linkTo: `${routes.PROJECTS}/${id}/chat`,
			linkPattern: `${routes.PROJECTS}/:id/chat`,
			icon: MessageSquare,
			component: ProjectChat,
		},
		{
			linkText: 'Map',
			linkTo: `${routes.PROJECTS}/${id}/maps`,
			linkPattern: `${routes.PROJECTS}/:id/maps`,
			icon: Map,
			component: ProjectMap,
		},
		{
			linkText: 'Financials',
			linkTo: `${routes.PROJECTS}/${id}/financials`,
			linkPattern: `${routes.PROJECTS}/:id/financials`,
			icon: DollarSign,
			component: ProjectFinancials,
		},
		{
			linkText: 'Details',
			linkTo: `${routes.PROJECTS}/${id}/details`,
			linkPattern: `${routes.PROJECTS}/:id/details`,
			icon: Info,
			component: ProjectDetails,
		},
		{
			linkText: 'Demographics',
			linkTo: `${routes.PROJECTS}/${id}/analytics`,
			linkPattern: `${routes.PROJECTS}/:id/analytics`,
			icon: BarChart3,
			component: ProjectAnalytics,
		},
		{
			linkText: 'Images',
			linkTo: `${routes.PROJECTS}/${id}/images`,
			linkPattern: `${routes.PROJECTS}/:id/images`,
			icon: Images,
			component: ProjectImages,
		},
		{
			linkText: 'Documents',
			linkTo: `${routes.PROJECTS}/${id}/files`,
			linkPattern: `${routes.PROJECTS}/:id/files`,
			icon: FileText,
			component: ProjectFiles,
		},
		{
			linkText: 'Partners',
			linkTo: `${routes.PROJECTS}/${id}/partners`,
			linkPattern: `${routes.PROJECTS}/:id/partners`,
			icon: Handshake,
			component: ProjectPartners,
		},
		{
			linkText: 'Reports',
			linkTo: `${routes.PROJECTS}/${id}/reports`,
			linkPattern: `${routes.PROJECTS}/:id/reports`,
			icon: FileBarChart,
			component: ProjectReports,
		},

		/*
		Redirect routes
	*/

		{
			linkPattern: `${routes.PROJECTS}/:id/addpartners`,
			component: LocationAddPartners,
		},

		// Default tab. `redirectFrom` is the bare project path so /projects/:id
		// (and any unmatched sub-path) lands on Tasks.
		{
			redirectFrom: `${routes.PROJECTS}/:id`,
			redirectTo: `${routes.PROJECTS}/${id}/tasks`,
		},
		// Hide the Financials tab from accounts without financials access
		// (community). Omitting `capabilities` shows everything (pro default).
	].filter((route: any) => {
		if (route.linkText === 'Financials' && capabilities && !capabilities.canSeeFinancials) {
			return false
		}
		return true
	})

export default getProjectRoutes
